const palette = {
  main: "#F9A35A",
  sub: "#F3EEEA",
  text: "#232323",
  box: "#F5F6F8",
  border: "#dbdbdb",
};

const shadow = {
  mainShadow: "1px 1px 3px rgba(249, 163, 90, 1)",
  boxShadow: "2px 3px 4px rgba(163, 163, 163, 0.35)",
  cardShadow: "8px 14px 34px -10px rgba(163, 163, 163, 0.35);",
};

const theme = {
  palette,
  shadow,
};

export default theme;
